import { LazyAction, LazyModule, createLazyComponent } from 'owa-bundling';
import { getIncompleteGetStartedTasksNumber } from './selectors/getIncompleteGetStartedTasksNumber';
import { getAllGetStartedTasksNumber } from './selectors/getAllGetStartedTasksNumber';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GetStarted" */ './lazyIndex');
});
export var GetStartedTaskContainer = createLazyComponent(lazyModule, function (m) { return m.GetStartedTaskContainer; });
export var initializeGetStartedTasksLazy = new LazyAction(lazyModule, function (m) { return m.initializeGetStartedTasks; });
export { getIncompleteGetStartedTasksNumber, getAllGetStartedTasksNumber };
//# sourceMappingURL=index.js.map